import { render } from "./PricesUpload.vue?vue&type=template&id=1ee49bb1&scoped=true"
import script from "./PricesUpload.vue?vue&type=script&lang=js"
export * from "./PricesUpload.vue?vue&type=script&lang=js"

import "./PricesUpload.vue?vue&type=style&index=0&id=1ee49bb1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ee49bb1"]])

export default __exports__